var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"dashboard-view"}},[_c('here-map',[(_vm.hasAllRoles(['DeviceView', 'VehicleView', 'DeviceEventView']))?_c('here-live-track'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }